module.exports = __webpack_public_path__ + "img/Feature.c5dcc38c.png";